import TeacherDashboardModule from './containers/teacherDashboardModule'

export {default as TeacherDashboardModuleLayout} from './components/teacherDashboardModuleLayout'

export default TeacherDashboardModule
